module.exports = __webpack_public_path__ + "img/Sidebar_bg.955d3c43.png";